import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=b98c58ea&scoped=true"
import script from "./Owners.vue?vue&type=script&lang=ts"
export * from "./Owners.vue?vue&type=script&lang=ts"
import style0 from "./Owners.vue?vue&type=style&index=0&id=b98c58ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c58ea",
  null
  
)

export default component.exports